// extracted by mini-css-extract-plugin
export default {"container":"ConfirmArchiveEvent_container__Olc56"};